import React from "react";
import Layout from "../../components/user/Layout";
import { useParams } from "react-router-dom"
import SearchList from "../../components/user/SearchSection";

const Search = () => {
    const { categoryID } = useParams();
    return (
        <>
            <Layout>

                <SearchList />
            </Layout>

        </>
    );
}

export default Search;